import { Discipline, DisciplineType } from '@/lib/types';

import { JobCategoryPageRouteParams } from '@/features/job-category-page/utils/route-utils';
import { routes } from '@/utils/route-utils';

export function buildJobCanonicalLink(
  params: JobCategoryPageRouteParams
): string | null {
  if (!params.disciplineType) {
    return null;
  }

  const canonicalParam =
    params.disciplineType === DisciplineType.Nurse
      ? params.specialty
      : params.discipline;

  if (!canonicalParam) {
    return null;
  }

  const segments: string[] = [];

  if (params.rawDisciplineType) {
    segments.push(params.rawDisciplineType);
  }

  if (params.rawDisciplineSubType) {
    segments.push(params.rawDisciplineSubType);
  }

  segments.push(canonicalParam);

  return `${routes.domain()}/healthcare-jobs/${segments.join('/')}`;
}

export function buildJobCanonicalLinkFromDiscipline(discipline: Discipline) {
  const isNurse = discipline.disciplineType === DisciplineType.Nurse;

  const rawPieces: (string | undefined)[] = [];

  if (isNurse) {
    rawPieces.push('nurse', 'travel-nurse');
  } else {
    rawPieces.push('allied', 'travel-allied', discipline.slug);
  }

  const pieces = rawPieces.filter(
    <T>(piece: T | undefined): piece is T => !!piece
  );
  return `/healthcare-jobs/${pieces.join('/')}`;
}
